var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDots = function SvgIconDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.005 13.63a1.625 1.625 0 1 0 0-3.25 1.625 1.625 0 0 0 0 3.25M12.005 7.63a1.625 1.625 0 1 0 0-3.25 1.625 1.625 0 0 0 0 3.25M12.005 19.63a1.625 1.625 0 1 0 0-3.25 1.625 1.625 0 0 0 0 3.25"
  }))));
};
export default SvgIconDots;